import React, { useState, useEffect } from 'react';

export const FadeInBlock = ({ children, delay }: { children?: React.ReactNode; delay: number }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <div className={`transition-all duration-300 ease-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`}>
      {children}
    </div>
  );
};

export const getAnimationClasses = (animationType?: string): string => {
  if (!animationType || animationType === 'none') return '';
  return 'hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200';
};
